import React from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead, MDBDataTable, MDBDataTableV5 } from 'mdbreact';
import * as misConstantes from '../../../js/constantes.js';
import InicioBreadcrumbs from '../../../pages/template/breadcrumbs/InicioBreadcrumbs.js'

import {
	Switch,
	Route,
	BrowserRouter,
	Link,
	useLocation,
	useParams
} from "react-router-dom";

import axios from "axios";



class Simuladores extends React.Component {
	constructor(props) {
	    super(props);

		

 		var columnas = [ 
								{ field: "nombre", label: "Nombre", attributes: {'width':'85%'} },
								{ field: "botones", label: "", attributes: {'width':'15%'} }
 
 						];
	    this.state = {  
	    						datos: {columns: columnas, rows:[]}
						};
	}
	componentDidMount() {
		this.cargarSimuladores();
//		ServletCatalogosProveedor
	}
	

	
	
	render(){
		 
	
		 return (
			<>
				<div class="menu" style={{backgroundColor:  "#dbe7fc", width: "100%", padding: "10px", fontSize: "12px" }}>
					<div class="container">
						<InicioBreadcrumbs></InicioBreadcrumbs> / Simuladores - Catalogos
					</div>
				</div>
				<div class="container" style={{minHeight: '550px', paddingTop: "30px"}}>
					<div class = 'subitulosPaginaNotificaciones'>
						<b>Simuladores - Catalogos</b>
					</div><br/>
					
							
							
					
					
					
					
					<MDBDataTable striped bordered  small data={ this.state.datos } hover entriesOptions={[5, 10, 15, 25]} entries={15} pagesAmount={4} condensed/>
					
				
				
				{ /**
				// ------------------------------------------------------------------------------------------------------
				// Cotizacion
				// ------------------------------------------------------------------------------------------------------
				 */}
				
					 
				</div>
			
			</>
			
		)
	}
	
	

	// ----------------------------------------
	// Cargar Cotizacion
	// ----------------------------------------
	handleCloseMostrarAprobacionModificacionOrdenCompra(){
		this.setState( {mostrarAprobacionModificacionOrdenCompra: false} );
	}
	handleAbrirMostrarAprobacionModificacionOrdenCompra(){
		this.setState( {mostrarAprobacionModificacionOrdenCompra: true} );
	}
	// ----------------------------------------
	// Cargar Cotizacion
	// ----------------------------------------
	cargarSimuladores(){
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var info = { "codigo": codigo};
		
		axios.post( misConstantes.URL_CONSULTA + '/ServletCatalogosProveedor', info, {params: info}).then(function (response) {
			var simuladores = response.data;
			
//			alert( JSON.stringify( simuladores ) );
			
			var columns = this.state.datos.columns;
			var rows = [];
			for( var i = 0; i < simuladores.length; i++ ){
				const identificador = simuladores[i].id + "";
				var simulador = simuladores[i].simulador;
				
//				alert(  simulador  );
				
				var row = {
							nombre: simulador.nombre + " - " + simuladores[i].nombre,
							botones: <div style = {{width: "100%", textAlign: "center" }}>
											<Link to = {'/precios-catalogo/' + simulador.id + "/" + identificador }><i class="fas fa-info-circle"></i></Link>&nbsp;
									</div>
						}
				rows.push(row);
			}

			var datos = {columns: columns, rows: rows}
			this.setState({datos: datos});
			
		}.bind(this)).catch(function (error) {
		});
	}
	
}

export default Simuladores;
